module.exports = __webpack_public_path__ + "img/favicon.3eead8e6.ico";